const privacyPolicyContent = `
  <h1>Privacy Policy</h1>
  <div>
    <h2>1. Introduction</h2>
    <p>This Privacy Policy explains how ReadRivals collects, uses, discloses, and safeguards your information when you use our mobile application. By using the app, you agree to the practices outlined in this policy.</p>

    <h2>2. Information We Collect</h2>
    <ul>
      <li><strong>Personal Information:</strong> Name, email, and any other information you provide when creating an account or contacting us.</li>
      <li><strong>Reading Activity:</strong> Words read, reading accuracy, session stats, and gameplay progress.</li>
      <li><strong>Device & Usage Data:</strong> Device type, OS version, and app usage analytics (e.g., crash logs, feature engagement).</li>
      <li><strong>Audio Data:</strong> Audio recordings used for speech analysis (optional; stored only if feature is enabled).</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <ul>
      <li>To analyze reading fluency and provide performance feedback.</li>
      <li>To improve app functionality and personalize content.</li>
      <li>To enable multiplayer and leaderboard features.</li>
      <li>For customer support and app improvement purposes.</li>
    </ul>

    <h2>4. Information Sharing</h2>
    <p>We do not sell your personal data. We may share information with trusted third-party service providers (e.g., Firebase, AWS) to help operate the app securely and reliably. These providers are contractually obligated to protect your data.</p>

    <h2>5. Child and Teen Privacy</h2>
    <p>We take the privacy of minors seriously. Our app is structured into separate experiences for children, teens, and adults. These variants do not allow interaction across age groups. We comply with COPPA and other applicable child data protection laws.</p>

    <h2>6. Data Retention</h2>
    <p>We retain your data only for as long as necessary to fulfill the purposes outlined in this policy unless a longer retention period is required by law. You may request account and data deletion at any time.</p>

    <h2>7. Your Rights</h2>
    <p>You have the right to access, correct, or delete your personal data. You can also opt-out of analytics or marketing features where applicable by contacting our support team.</p>

    <h2>8. Security</h2>
    <p>We use secure cloud services and industry-standard encryption to protect your data. While we strive to use commercially acceptable means to protect your personal information, no method of transmission over the Internet is 100% secure.</p>

    <h2>9. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by updating the date below and, when required, through in-app notifications.</p>

    <h2>10. Contact Us</h2>
    <p>If you have any questions or requests related to this Privacy Policy, you can contact us at: <a href="mailto:support@readrivals.com">generalquestions@readwellllc.com</a></p>

    <p><em>Last updated: June 22, 2025</em></p>
  </div>
`;

export default privacyPolicyContent;